

import { useState } from "react";
import { ClipboardCopy, Check } from "lucide-react";

export default function CopyButton({
  text,
  className = "",
  size = 16,
}: {
  text: string;
  className?: string;
  size?: number;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // ignore
      console.error("Failed to copy", err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`flex items-center gap-2 rounded-xl bg-white/10 p-2 text-xs ${className}`}
      aria-label={copied ? "Copied" : "Copy link"}
    >
      {copied ? (
        <>
          <Check style={{ width: size, height: size }} />
          <span className="hidden sm:inline">Copied</span>
        </>
      ) : (
        <>
          <ClipboardCopy style={{ width: size, height: size }} />
          <span className="hidden sm:inline">Copy</span>
        </>
      )}
    </button>
  );
}
